export default "__VITE_ASSET__68f404be__"